import { PlusOutlined, CloseCircleOutlined, CrownOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Card, Button, Tooltip } from "antd";
import './ClassBenefits.scss'
import { Icon_Wrapper } from "../../../components/ExportImgFigma";

interface BenefitCardProps {
    item: {
        id: number;
        title: string;
        description?: string;
    };
    selected: boolean;
    onToggle: (id: number) => void;
}

const BenefitCard: React.FC<BenefitCardProps> = ({
    item,
    selected,
    onToggle
}) => {
    return (
        <div
            key={item.id}
            className={`benefit-list__item${selected ? ' benefit-list__item--expanded' : ''}`}
        >
            <div className="benefit-list__item-header">
                <div className="benefit-list__item-title "
                    style={{
                        width: '80%'
                    }}>
                    <CrownOutlined className="benefit-list__item-icon" />
                    <Tooltip
                        title={
                            <span className="font-regular "

                            >{item.title}</span>
                        }
                    >
                        <span className="font-regular text-truncate"
                        >{item.title}</span>
                    </Tooltip>

                </div>
                <button
                    className="benefit-list__item-btn"
                    onClick={() => onToggle(item.id)}
                >
                    {selected
                        ? <CloseCircleOutlined className="btn-icon btn-icon--close" />
                        : <PlusCircleOutlined className="btn-icon btn-icon--plus" />
                    }
                </button>
            </div>
            {selected && item.description && (
                <div className="benefit-list__item-desc">{item.description}</div>
            )}
        </div>
    );
};

export default BenefitCard